import React from 'react'

export default function NotFound() {
  return (
    <div className='text-3xl font-bold'>404  Not Found</div>
  )
}
